import hello from './HelloWorld'
import popup from './Popup'
export default {
	hello,
	popup
}


//////////////////
// WEBPACK FOOTER
// ./src/components/index.js
// module id = null
// module chunks = 